var map = {
	"./big.png": "fad3",
	"./db@2x.png": "d560",
	"./dragon1.png": "aee1",
	"./goldFront.png": "a26c",
	"./ii-1@2x.png": "d0e1",
	"./ii-2@2x.png": "07c2",
	"./lv@2x.png": "b55c",
	"./plus@2x.png": "d38b",
	"./sp@2x.png": "7724",
	"./world.png": "d1a6",
	"./zc@2x.png": "6fc0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15b8";